export default __webpack_public_path__ + "static/media/user_1.dc87de17.svg";